import React from "react";
import { injectIntl } from "@irati/utils/lang";
import { H2, H3 } from "@irati/ui/src/Typography";
var Free = function (_a) {
    var id = _a.id, emoji = _a.emoji, formatMessage = _a.formatMessage, small = _a.small;
    var savingsTypeHeader = formatMessage({ id: "perks.saving.free" });
    var Heading = small ? H3 : H2;
    return (React.createElement(Heading, { id: id, "data-test": "free" }, emoji + " " + savingsTypeHeader));
};
export default injectIntl(Free);
